export default "__VITE_ASSET__3f2b3e2a__"